import React from "react";
import { Link } from "react-router-dom";
import isEmpty from "lodash.isempty";

export default ({ companies, onClickDelete }) => {
  const TableOrNotFound = () => {
    if (companies.loading) {
      return "is Loading";
    }
    if (isEmpty(companies.data)) {
      return (
        <p className="is-size-2 has-text-centered has-text-grey">
          Found Nothing
        </p>
      );
    }
    return (
      <table className="table is-fullwidth is-striped is-hoverable">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>URL</th>
            <th>Disk Capacity</th>
            <th>Rate Limit</th>
            <th>Released at</th>
            <th>Expired at</th>
            <th>Article Count</th>
            <th>SMS Credits</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {companies.data.map(company => (
            <tr key={company.id}>
              <td>
                <a>{company.id}</a>
              </td>
              <td>{company.name}</td>
              <td>{company.url}</td>
              <td>{company.disk_capacity}</td>
              <td>{company.rate_limit}</td>
              <td>{company.released_at}</td>
              <td>{company.expired_at}</td>
              <td>{company.articles ? company.articles.length : 0}</td>
              <td>{company.sms_credits}</td>

              <td className="is-icon">
                <p className="buttons">
                  <Link
                    to={`/companies/${company.id}/sms-reloads`}
                    className="button  is-link is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-eye" />
                    </span>
                    <span>View SMS Reload</span>
                  </Link>
                  <Link
                    to={`/companies/${company.id}/edit`}
                    className="button  is-link is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-edit" />
                    </span>
                    <span>Edit</span>
                  </Link>
                  <a
                    onClick={onClickDelete(company.id)}
                    to={`/companies/${company.id}/delete`}
                    className="button is-danger is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-trash" />
                    </span>
                    <span>Delete</span>
                  </a>
                </p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };
  return (
    <section className="section">
      <TableOrNotFound />
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/pages/Company/Index/Table.js